function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0-2h130v130H0z",
  fill: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 65,
  cy: 63,
  r: 56
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  "data-name": "b",
  cx: 65,
  cy: 63,
  r: 56,
  fill: "#fff",
  stroke: "#12123b",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "<Group>"
}, React.createElement("path", {
  "data-name": "<Path>",
  d: "M58.7 81.91a6.3 6.3 0 0012.6 0v-.33H58.7z",
  fill: "#acabb1"
}), React.createElement("path", {
  "data-name": "<Path>",
  fill: "#565659",
  d: "M65 77.6h-6.3v3.98h12.6V77.6H65z"
}), React.createElement("path", {
  "data-name": "<Path>",
  d: "M63 64.71a7.31 7.31 0 01-5.31-7h4A3.32 3.32 0 0065 61V37.79a17.34 17.34 0 00-8.65 32.36l2.35 7.45H63z",
  fill: "#fab7ce"
}), React.createElement("path", {
  "data-name": "<Path>",
  d: "M65 37.79V61a3.32 3.32 0 003.32-3.32h4a7.31 7.31 0 01-5.31 7V77.6h4.29l2.35-7.45A17.34 17.34 0 0065 37.79z",
  fill: "#3fcecb"
}), React.createElement("path", {
  "data-name": "<Path>",
  d: "M61.68 57.69h-4a7.31 7.31 0 005.31 7V77.6h4V64.71a7.31 7.31 0 005.31-7h-4a3.32 3.32 0 11-6.64 0z",
  fill: "#ff6231"
}));

var SvgIcRgb = function SvgIcRgb(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMzAgMTMwIj48dGl0bGU+aWMtcmdiPC90aXRsZT48cGF0aCBkPSJNMC0ySDEzMFYxMjhIMFoiIHN0eWxlPSJmaWxsOm5vbmUiLz48Y2lyY2xlIGlkPSJiIiBjeD0iNjUiIGN5PSI2MyIgcj0iNTYiLz48Y2lyY2xlIGlkPSJiLTIiIGRhdGEtbmFtZT0iYiIgY3g9IjY1IiBjeT0iNjMiIHI9IjU2IiBzdHlsZT0iZmlsbDojZmZmO3N0cm9rZTojMTIxMjNiO3N0cm9rZS13aWR0aDoycHgiLz48ZyBpZD0iX0dyb3VwXyIgZGF0YS1uYW1lPSImbHQ7R3JvdXAmZ3Q7Ij48cGF0aCBpZD0iX1BhdGhfIiBkYXRhLW5hbWU9IiZsdDtQYXRoJmd0OyIgZD0iTTU4LjcsODEuOTFhNi4zLDYuMywwLDAsMCwxMi42LDB2LS4zM0g1OC43WiIgc3R5bGU9ImZpbGw6I2FjYWJiMSIvPjxwb2x5Z29uIGlkPSJfUGF0aF8yIiBkYXRhLW5hbWU9IiZsdDtQYXRoJmd0OyIgcG9pbnRzPSI2NSA3Ny42IDYzLjAxIDc3LjYgNTguNyA3Ny42IDU4LjcgODEuNTggNzEuMyA4MS41OCA3MS4zIDc3LjYgNjYuOTkgNzcuNiA2NSA3Ny42IiBzdHlsZT0iZmlsbDojNTY1NjU5Ii8+PHBhdGggaWQ9Il9QYXRoXzMiIGRhdGEtbmFtZT0iJmx0O1BhdGgmZ3Q7IiBkPSJNNjMsNjQuNzFhNy4zMSw3LjMxLDAsMCwxLTUuMzEtN2g0QTMuMzIsMy4zMiwwLDAsMCw2NSw2MVYzNy43OWExNy4zNCwxNy4zNCwwLDAsMC04LjY1LDMyLjM2TDU4LjcsNzcuNkg2M1oiIHN0eWxlPSJmaWxsOiNmYWI3Y2UiLz48cGF0aCBpZD0iX1BhdGhfNCIgZGF0YS1uYW1lPSImbHQ7UGF0aCZndDsiIGQ9Ik02NSwzNy43OVY2MWEzLjMyLDMuMzIsMCwwLDAsMy4zMi0zLjMyaDRhNy4zMSw3LjMxLDAsMCwxLTUuMzEsN1Y3Ny42SDcxLjNsMi4zNS03LjQ1QTE3LjM0LDE3LjM0LDAsMCwwLDY1LDM3Ljc5WiIgc3R5bGU9ImZpbGw6IzNmY2VjYiIvPjxwYXRoIGlkPSJfUGF0aF81IiBkYXRhLW5hbWU9IiZsdDtQYXRoJmd0OyIgZD0iTTYxLjY4LDU3LjY5aC00YTcuMzEsNy4zMSwwLDAsMCw1LjMxLDdWNzcuNmg0VjY0LjcxYTcuMzEsNy4zMSwwLDAsMCw1LjMxLTdoLTRhMy4zMiwzLjMyLDAsMSwxLTYuNjQsMFoiIHN0eWxlPSJmaWxsOiNmZjYyMzEiLz48L2c+PC9zdmc+";
export { SvgIcRgb as ReactComponent };